export const getAvailableGroupOptions = (groups, optionKeys) => {
    const usedBaseOptions = new Set((Array.isArray(groups) ? groups : []).map(group => group?.baseOption).filter(Boolean));
    return optionKeys.filter(optionKey => !usedBaseOptions.has(optionKey));
};

export const getAvailableInGroupOptions = (groups, optionKeys, groupIndex) => {
    if (groupIndex === null || groupIndex === undefined) return optionKeys;
    const safeGroups = Array.isArray(groups) ? groups : [];
    const group = safeGroups[groupIndex];
    if (!group) return optionKeys;

    const usedInGroupSet = new Set();
    if (group.baseOption) usedInGroupSet.add(group.baseOption);

    if (Array.isArray(group.subgroups)) {
        group.subgroups.forEach(subgroup => {
            if (Array.isArray(subgroup?.rows)) {
                subgroup.rows.forEach(row => {
                    if (row?.option) usedInGroupSet.add(row.option);
                });
            }
        });
    }

    return optionKeys.filter(optionKey => !usedInGroupSet.has(optionKey));
};
